import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageLevels,
  PageLevel,
} from '../pages/levels';

const RouteLevels = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageLevels />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageLevel />
      </Route>
    </Switch>
  );
};

export default RouteLevels;
